import { render, staticRenderFns } from "./PlantillaContenido.vue?vue&type=template&id=d2e6a8fc&"
import script from "./PlantillaContenido.vue?vue&type=script&lang=js&"
export * from "./PlantillaContenido.vue?vue&type=script&lang=js&"
import style0 from "./PlantillaContenido.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PlantillaContenido.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports